var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kgk-register"},[_c('RegisterForm',{attrs:{"invite-id":_vm.$route.params.inviteId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }